// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/stage-outcome-canary/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/stage-outcome-canary/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Đã cập nhật ${data.items.length} ${targetType === " })
  return <Page />
}
